import React, { useState, useEffect } from "react";
import AdminSidePanel from "./AdminSidePanel";
import { Link } from "react-router-dom";
import { FaPlusCircle } from "react-icons/fa";
import { useCookies } from "react-cookie";
import axios from "axios";
import propertyPhoto from "../../assets/images/house2.png";


function AdminStaffView({ location }) {

  const [cookies, removeCookie] = useCookies(["Authorization"]);

  console.log("location.state in AdminStaffView page is", location.state)
  const staffData = { ...location.state.details };
  console.log(staffData);


  return (
    <div>

      <main className="admin-panel">
        <div className="row">
          <div className="col-lg-2">
            <AdminSidePanel />
          </div>
          <div className="col-lg-9">
            <div className="admin-sitemap">
              Admin Panel {">"} Site Manager {">"} Staff {">"} taff
            </div>
            <br></br>
            <br></br>
          </div>
        </div>
        <div className="property-info">
          <div className="property-info-text">
            <br></br><br></br>
            <h3>Staff Name: {staffData.fname} </h3>
            <br></br><br></br>
            <h4>Staff Email: {staffData.email}</h4>
            <br></br><br></br>
            <h4>Staff Contact Number: {staffData.contactNo}</h4>
            <br></br><br></br>
            <h4>Staff Status: {staffData.status}</h4>
            <br></br><br></br>
            <h4>Staff Address: {staffData.address}</h4>
          </div>
        </div>
        <br></br><br></br><br></br><br></br>
      </main>



    </div>
  )
}

export default AdminStaffView;